import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import Icon from "@material-ui/core/Icon";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";

import buttonStyle from "assets/jss/material-dashboard-react/components/buttonStyle.jsx";
import Tooltip from "@material-ui/core/Tooltip";

function RegularButton({ ...props }) {
  const {
    classes,
    color,
    round,
    children,
    disabled,
    simple,
    size,
    block,
    link,
    icon,
    image,
    justIcon,
    isMobile,
    tooltip,
    className,
    muiClasses,
    ...rest
  } = props;
  const btnClasses = classNames({
    [classes.button]: true,
    [classes[size]]: size,
    [classes[color]]: color,
    [classes.round]: round,
    [classes.disabled]: disabled,
    [classes.simple]: simple,
    [classes.block]: block,
    [classes.link]: link,
    [classes.icon]: icon,
    [classes.image]: image,
    [classes.justIcon]: justIcon,
    [classes.isMobile]: isMobile,
    [classes.tooltip]: tooltip,
    [className]: className
  });
  return (
    <>{
      <>{tooltip ? (
        <Tooltip title={tooltip} placement="top-start" arrow="true">
          <Button {...rest} classes={muiClasses} className={btnClasses}>
            {icon ? <Icon>{icon}</Icon> : ''}
            {image ? <>{image}</> : ''}
            {children}
          </Button>
        </Tooltip>
        ) : <>
        <Button {...rest} classes={muiClasses} className={btnClasses}>
          {icon ? <Icon>{icon}</Icon> : ''}
          {children}
        </Button>
        </>
      }</>
    }</>
  );
}

RegularButton.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "indigo",
    "gray",
    "white",
    "transparent"
  ]),
  size: PropTypes.oneOf(["sm", "lg"]),
  simple: PropTypes.bool,
  round: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  isMobile: PropTypes.bool,
  icon: PropTypes.string,
  image: PropTypes.object,
  tooltip: PropTypes.string,
  className: PropTypes.string,
  // use this to pass the classes props from Material-UI
  muiClasses: PropTypes.object
};

export default withStyles(buttonStyle)(RegularButton);
